import VideoJS from 'video.js';

import Analtyics from './analytics';

import { inIframe } from '../utils/ASVPUtils';

import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';

import asIcon from '../icons/as.svg';
import ccIcon from '../icons/cc.svg';
import exitFullscreenIcon from '../icons/exit-fullscreen.svg';
import fullscreenIcon from '../icons/fullscreen.svg';
import volumeIcon from '../icons/volume.svg';
import mutedIcon from '../icons/muted.svg';
import playIcon from '../icons/play.svg';
import pauseIcon from '../icons/pause.svg';

import shareOverlay from 'html!./controls/share-overlay.html';
import { Component } from './controls/component';

import {
    LOCALSTORAGE_MUTED,
    FACEBOOK_SHARE_URL,
    TWITTER_SHARE_URL,
    TUMBLR_SHARE_URL,
    AS_VIDEOS_URL,
    EMBED_CODE_L,
    EMBED_CODE_R,
    EMBED_URL,
    NOISE
} from '../config/player';



var Controls = function (player, videoData, options) {
    this.player = player;
    this.videoData = videoData;
    this.options = options || {};

    this.ASVolumeControl = Component('ASVolumeControl', 'as-volume-control vjs-control', '<div class="as-volume-slider-wrapper"><div class="as-volume-slider"><div class="as-volume-bar"></div></div></div>');
    this.ASIconControl = Component('ASIconControl', 'as-icon-control vjs-control', asIcon);
    this.ASShareControl = Component('ASShareControl', 'as-share-control vjs-control', '<div class="as-share">Share</div>');
    this.ASShareOverlay = Component('ASShareOverlay', 'vjs-overlay', shareOverlay);
    this.ASAdCountdown = Component('ASAdCountdown', 'as-ad-countdown', 'AD: <span class="time-remaining"></span>');

    this.setBigPlayButton();
    this.setPlayToggle();
    this.setMuteToggle();
    this.setVolumeControl();
    this.setProgressControl();
    this.setShareControl();
    this.setCurrentTimeDisplay();
    this.setCaptionsButton();
    // this.setSubtitlesButton();
    this.setFullscreenToggle();

    return this;
};


Controls.prototype.setBigPlayButton = function () {
    let bigPlayButton = this.player.bigPlayButton;

    bigPlayButton.controlText('<span>');
    bigPlayButton.el().setAttribute('title', 'Play');
};


Controls.prototype.setPlayToggle = function () {
    let playSVG = document.createElement('span');
    let pauseSVG = document.createElement('span');
    let playToggle = this.player.controlBar.playToggle;

    playSVG.innerHTML = playIcon;
    pauseSVG.innerHTML = pauseIcon;

    this.player.on('play', () => {
        playToggle.controlText(pauseSVG.innerHTML);
        playToggle.el().setAttribute('title', 'Pause');
    });

    this.player.on('pause', () => {
        playToggle.controlText(playSVG.innerHTML);
        playToggle.el().setAttribute('title', 'Play');
    });

    playToggle.controlText(playSVG.innerHTML);
    playToggle.el().setAttribute('title', 'Play');
};


Controls.prototype.setMuteToggle = function () {
    this.lastVolume = this.player.volume();

    this.player.on('ready', () => {
        // on volume change, save the state of the volume
        this.player.on('volumechange', () => {
            window.localStorage.setItem(LOCALSTORAGE_MUTED, this.muteIcons());
        });
    }).on('loadstart', () => {
        this.muteIcons();
    });
};


Controls.prototype.muteIcons = function () {
    var mutedSVG = document.createElement('span');
    var volumeSVG = document.createElement('span');
    var muteToggle = this.player.controlBar.muteToggle;
    var ASVolumeBar = document.querySelector('.as-volume-bar');
    var isMuted = this.player.muted();

    mutedSVG.innerHTML = mutedIcon;
    volumeSVG.innerHTML = volumeIcon;

    if (isMuted) {
        muteToggle.controlText(mutedSVG.innerHTML);
        muteToggle.el().setAttribute('title', 'Unmute');
        ASVolumeBar.style.width = '0%';
    } else {
        muteToggle.controlText(volumeSVG.innerHTML);
        muteToggle.el().setAttribute('title', 'Mute');
        if (this.lastVolume) ASVolumeBar.style.width = (this.lastVolume * 100) + '%';
    }

    return isMuted;
};


Controls.prototype.setVolumeControl = function () {
    var volumeDrag = false;
    var volumeControl = this.player.controlBar.addChild(this.ASVolumeControl);
    var ASVolumeSlider = document.querySelector('.as-volume-slider');
    var ASVolumeBar = document.querySelector('.as-volume-bar');
    var muteToggle = this.player.controlBar.muteToggle;

    /* Volume Slider drag and click events */
    ASVolumeSlider.addEventListener('mousedown', (e) => {
        volumeDrag = true;
        this.updateVolume(e.pageX);
    });
    document.addEventListener('mouseup', (e) => {
        if (volumeDrag) {
            volumeDrag = false;
            this.updateVolume(e.pageX);
        }
    });
    document.addEventListener('mousemove', (e) => {
        if (volumeDrag) {
            this.updateVolume(e.pageX);
        }
    });

    ASVolumeBar.style.width = (this.player.volume() * 100) + '%';

    /* Handle Rollovers for show volume control */
    muteToggle.on('mouseover', () => {
        volumeControl.addClass('show-volume-control');
    });
    muteToggle.on('mouseout', () => {
        volumeControl.removeClass('show-volume-control');
    });

    volumeControl.on('mouseover', () => {
        volumeControl.addClass('show-volume-control');
    });
    volumeControl.on('mouseout', () => {
        volumeControl.removeClass('show-volume-control');
    });
};

Controls.prototype.updateVolume = function (mousePosX) {
    var ASVolumeSlider = document.querySelector('.as-volume-slider');
    var ASVolumeBar = document.querySelector('.as-volume-bar');
    var position = mousePosX - ASVolumeSlider.getBoundingClientRect().left;
    var percentage;

    percentage = 100 * (position / ASVolumeSlider.offsetWidth);

    if (percentage > 100) percentage = 100;

    if (percentage < 0) percentage = 0;

    //update volume bar and video volume
    ASVolumeBar.style.width = percentage + '%';
    this.player.volume(percentage / 100);
    this.lastVolume = this.player.volume();

    //change sound icon based on volume
    if (this.player.volume() === 0) {
        this.player.muted(true);
    } else {
        this.player.muted(false);
    }
};


Controls.prototype.setProgressControl = function () {
    var progressControl = this.player.controlBar.progressControl;
    var loadProgress = progressControl.seekBar.loadProgressBar;
    var playProgress = progressControl.seekBar.playProgressBar;
    var progressTimeDisplay = document.createElement('div');
    var mouseX;

    loadProgress.el_.innerHTML = '';
    playProgress.el_.innerHTML = '';

    progressTimeDisplay.className = 'progress-time-display';
    progressControl.el_.appendChild(progressTimeDisplay);

    this.setProgressTimeDisplayPosition = (e) => {
        mouseX = e.offsetX;
        var duration = this.player.duration();
        var progressWidth = progressControl.el_.offsetWidth;
        var time = VideoJS.formatTime((duration / progressWidth) * mouseX, this.player.duration());

        progressTimeDisplay.style.left = mouseX - (progressTimeDisplay.offsetWidth / 2) + 'px';
        progressTimeDisplay.textContent = time;
    };

    progressControl.el_.addEventListener('mousemove', this.setProgressTimeDisplayPosition);
};


Controls.prototype.setCurrentTimeDisplay = function () {
    var showCurrentTime = () => {
        var currentTimeDisplay = this.player.controlBar.currentTimeDisplay;

        var time = (this.player.scrubbing) ? this.player.getCache().currentTime : this.player.currentTime();
        currentTimeDisplay.contentEl_.innerHTML = VideoJS.formatTime(time, this.player.duration());
    };

    showCurrentTime();

    this.player.on('timeupdate', showCurrentTime);
};



Controls.prototype.setShareControl = function () {
    this.player.controlBar.removeChild(this.ASShareControl);

    // if explicitly turned off, don't share this
    if (this.options.share === false) return false;

    // if not a clip, don't show share button
    if (this.videoData && this.videoData.type !== 'clip') return false;

    function removeShareOverlay(e) {
        this.player.removeChild(this.ASShareOverlay);

        this.player.play();
    }

    function noise(e) {
        // remove any previous noise sound nodes
        var noiseDiv = document.querySelector('#noise');
        if (noiseDiv) document.body.removeChild(noiseDiv);

        var sound = document.createElement('audio');
        sound.setAttribute('src', NOISE);
        sound.setAttribute('id', 'noise');
        sound.setAttribute('autoplay', 'true');
        document.body.appendChild(sound);

        Analtyics.trackUserInteraction(this.videoData, { interaction: e.currentTarget.getAttribute('data-user-interaction') });
    }

    function socialClick(e) {
        Analtyics.trackUserInteraction(this.videoData, { interaction: e.currentTarget.getAttribute('data-user-interaction') });
    }

    var showShareOverlay = (e) => {
        this.removeShareOverlay();
        this.player.pause();

        this.player.addClass('as-sharing');

        var url = AS_VIDEOS_URL + kebabCase(this.videoData.collection_title) + '/' + kebabCase(this.videoData.title) + '/';
        var shareOverlay = this.player.addChild(this.ASShareOverlay);
        var closeButton = shareOverlay.el().querySelector('.close-button');
        var facebookShareAnchor = shareOverlay.el().querySelector('.facebook-icon > a');
        var twitterShareAnchor = shareOverlay.el().querySelector('.twitter-icon > a');
        var tumblrShareAnchor = shareOverlay.el().querySelector('.tumblr-icon > a');
        var noiseIcon = shareOverlay.el().querySelector('.noise-icon');
        var directLinkAnchor = shareOverlay.el().querySelector('.direct-link-url');
        var embedCodeInput = shareOverlay.el().querySelector('.embed-code-input input');

        // if share link override is set, use it for the url
        var overrideShareURL = get(this.options, 'share.url');
        if (overrideShareURL) url = overrideShareURL;

        // if set, passes the override share url to the embed player options
        var shareParam = (overrideShareURL) ? '?s=' + url : '';

        facebookShareAnchor.setAttribute('href', FACEBOOK_SHARE_URL + url);
        twitterShareAnchor.setAttribute('href', TWITTER_SHARE_URL + url);
        tumblrShareAnchor.setAttribute('href', TUMBLR_SHARE_URL + url);

        noiseIcon.removeEventListener('click', noise.bind(this));
        noiseIcon.addEventListener('click', noise.bind(this));

        facebookShareAnchor.removeEventListener('click', socialClick.bind(this));
        facebookShareAnchor.addEventListener('click', socialClick.bind(this));
        twitterShareAnchor.removeEventListener('click', socialClick.bind(this));
        twitterShareAnchor.addEventListener('click', socialClick.bind(this));
        tumblrShareAnchor.removeEventListener('click', socialClick.bind(this));
        tumblrShareAnchor.addEventListener('click', socialClick.bind(this));

        directLinkAnchor.setAttribute('href', url);
        directLinkAnchor.innerHTML = url;

        embedCodeInput.value = EMBED_CODE_L + EMBED_URL + this.videoData.id + shareParam + EMBED_CODE_R;
        embedCodeInput.setSelectionRange(0, embedCodeInput.value.length);

        closeButton.removeEventListener('click', removeShareOverlay);
        closeButton.addEventListener('click', removeShareOverlay);
    };

    showShareOverlay = showShareOverlay.bind(this);
    removeShareOverlay = removeShareOverlay.bind(this);

    var ASShareButton = this.player.controlBar.addChild(this.ASShareControl).el();

    ASShareButton.removeEventListener('click', showShareOverlay);
    ASShareButton.addEventListener('click', showShareOverlay);
};


Controls.prototype.removeShareOverlay = function () {
    this.player.removeChild(this.ASShareOverlay);
};



Controls.prototype.setCaptionsButton = function () {
    var ccSVG = document.createElement('span');
    var captionsButton = this.player.controlBar.captionsButton;

    ccSVG.innerHTML = ccIcon;

    captionsButton.on('mouseover', function () {
        var menu = captionsButton.children_[0];

        // replace Unknown CC1 with English
        for (var i = 0; i < menu.el_.children[0].children.length; i++) {
            var listItem = menu.el_.children[0].children[i];
            if (listItem.textContent.includes('Unknown')) listItem.textContent = 'English';
        }

        menu.addClass('show-vjs-menu');
        menu.el_.style.top = '-' + menu.el_.offsetHeight + 'px';
    });

    captionsButton.on('mouseout', function () {
        captionsButton.children_[0].removeClass('show-vjs-menu');
    });

    captionsButton.controlText(ccSVG.innerHTML);
    captionsButton.el().setAttribute('title', 'Closed Captions');
};


Controls.prototype.setSubtitlesButton = function () {
    var ccSVG = document.createElement('span');
    var subtitlesButton = this.player.controlBar.subtitlesButton;

    ccSVG.innerHTML = ccIcon;

    subtitlesButton.on('mouseover', function () {
        var menu = subtitlesButton.children_[0];

        // replace Unknown CC1 with English
        for (var i = 0; i < menu.el_.children[0].children.length; i++) {
            var listItem = menu.el_.children[0].children[i];
            if (listItem.textContent.includes('Unknown')) listItem.textContent = 'English';
        }

        menu.addClass('show-vjs-menu');
        menu.el_.style.top = '-' + menu.el_.offsetHeight + 'px';
    });

    subtitlesButton.on('mouseout', function () {
        subtitlesButton.children_[0].removeClass('show-vjs-menu');
    });

    subtitlesButton.controlText(ccSVG.innerHTML);
    subtitlesButton.el().setAttribute('title', 'Closed Captions');
};


Controls.prototype.setFullscreenToggle = function () {
    var fullscreenIcons = () => {
        var fullscreenSVG = document.createElement('span');
        var exitFullscreenSVG = document.createElement('span');
        var fullscreenToggle = this.player.controlBar.fullscreenToggle;

        fullscreenSVG.innerHTML = fullscreenIcon;
        exitFullscreenSVG.innerHTML = exitFullscreenIcon;

        if (!this.player.isFullscreen()) {
            fullscreenToggle.controlText(fullscreenSVG.innerHTML);
            fullscreenToggle.el().setAttribute('title', 'Fullscreen');
        } else {
            fullscreenToggle.controlText(exitFullscreenSVG.innerHTML);
            fullscreenToggle.el().setAttribute('title', 'Exit Fullscreen');
        }
    };

    fullscreenIcons();

    this.player.on('fullscreenchange', fullscreenIcons);

};


Controls.prototype.setASIconControl = function () {
    var ASIconControl = this.player.controlBar.addChild(this.ASIconControl);
    var url = AS_VIDEOS_URL + kebabCase(this.videoData.collection_title) + '/' + kebabCase(this.videoData.title) + '/';

    var navigate = () => {
        var currentTime = this.player.currentTime();
        var duration = this.player.duration();
        var timecode = '';

        this.player.pause();

        if (currentTime !== duration) timecode = '?t=' + Math.round(currentTime);

        window.open(url + timecode, '_blank');
    };

    ASIconControl.on('click', navigate);
};


Controls.prototype.setVideoData = function (videoData) {
    this.videoData = videoData;
    this.setShareControl();
    if (inIframe()) this.setASIconControl();
};


Controls.prototype.setMidrollPoints = function (midrolls) {
    var progressControl = this.player.controlBar.progressControl;
    var midrollClassName = 'midroll-dot';

    var previousMidrolls = progressControl.el_.getElementsByClassName(midrollClassName);
    while (previousMidrolls.length > 0) {
        previousMidrolls[0].parentNode.removeChild(previousMidrolls[0]);
    }

    if (!midrolls.length) return;

    for (var i = 0; i < midrolls.length; i++) {
        var slot = midrolls[i];
        var slotTimePosition = slot.getTimePosition();
        var div = document.createElement('div');

        div.className = midrollClassName;
        div.style.left = ((slotTimePosition / this.player.duration()) * 100) + '%';
        progressControl.el_.appendChild(div);
    }
};


Controls.prototype.adCountdown = function (slot) {
    this.player.off('timeupdate', showAdRemainingTime);
    this.player.removeChild(this.ASAdCountdown);

    if (!slot) return;

    this.slot = slot;
    this.totalAdDuration = slot.getTotalDuration();

    this.player.addChild(this.ASAdCountdown);
    var asAdCountdown = this.player.getChild(this.ASAdCountdown);
    this.timeRemainingSpan = asAdCountdown.el().querySelector('.time-remaining');

    showAdRemainingTime = showAdRemainingTime.bind(this);
    this.player.on('timeupdate', showAdRemainingTime);
};


var showAdRemainingTime = function () {
    this.timeRemainingSpan.innerHTML = VideoJS.formatTime(this.totalAdDuration - Math.round(this.slot.getPlayheadTime()), 'M:SS');
};

export default Controls;


// WEBPACK FOOTER //
// ./src/player/controls.js